import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native'
import { Slider, SliderProps } from '@miblanchard/react-native-slider'
import { Ref, useImperativeHandle } from 'react'

import { Color } from '../../style'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  track: {
    height: 2,
  },
})

interface Props extends Omit<SliderProps, 'animationType'> {
  style?: StyleProp<ViewStyle>
  value?: number
  onChange?: (value: number) => void
  test_ref?: Ref<any>
}

const SliderInput = (props: Props) => {
  const { test_ref, style, onChange, ...otherProps } = props

  function changeValue(value: number[]) {
    onChange?.(value?.[0])
  }

  useImperativeHandle(test_ref, () => ({
    changeValue: (value: number[]) => {
      changeValue(value)
    },
  }))

  return (
    <View style={style}>
      <Slider
        containerStyle={styles.container}
        thumbTintColor={Color.premiumBlack}
        maximumTrackTintColor={Color.calmGrey}
        trackStyle={styles.track}
        animationType="timing"
        thumbTouchSize={{ width: 40, height: 40 }}
        onValueChange={changeValue}
        {...otherProps}
      />
    </View>
  )
}

export default SliderInput
